module.exports = __webpack_public_path__ + "static/img/hema.4fb7e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hema.png
// module id = iYZu
// module chunks = 1